import { gql } from '@apollo/client/core';

// eslint-disable-next-line import/prefer-default-export
export const CREATE_JOB_RECRUIT = gql`
  mutation CreateJobRecruit($jobId: UUID!, $providerId: UUID!) {
    createJobRecruit(jobId: $jobId, providerId: $providerId) {
      jobId
    }
  }
`;
